<template>
    <div>
        <div v-for="(value, key) in showData" style="width: 1300px;margin: 0 auto;">
            <div><h3>{{key}}</h3></div>
            <hr>
            <div v-for="val in value" style="display: inline-block;width: 250px;height: 272px;margin-right: 10px;">
                <el-popover trigger="click" placement="right" >
                <div slot="reference" style="width: 250px;height: 250px;cursor: pointer;">
                <img onclick="" :src="val.photo_url" style="max-width: 250px;max-height: 250px;">
                </div>
                <div>
                    {{val.photo_msg}}
                </div>
                </el-popover>
                <div style="height: 22px;">{{val.photo_name}}</div>
            </div>
            <hr>
        </div>
    </div>
</template>


<script>
import api from '@/http/request'

export default {
    name: "product",
    data () {
        return {
            showData:[],
            now_show:'',
        }
    },
    watch: {
        '$router' (to, from) {
            if (to.path === '/api/getListTest') {
                this.message = this.$router.query.msg;
            }
        },

    },
    mounted: function () {
        this.my_data();
    },

    methods: {
        my_data: function () {
            this.$axios({
                method:'get',
                url:'/api/pre/json_go/we_photo',
            }).then((response) =>{ // ����ʹ����ES6���﷨
                this.showData = response.data;
            }).catch((error) =>
                console.log(error)       //����ʧ�ܷ��ص�����
            )
        },
    },
    destroyed () {
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/about/corporateculture.vue